import { requestAndParse, requestSuccessful } from '../request';

const deleteStudy = async (id: number) => {
    const route = 'admin/delete-study';
    const payload = { id };

    const response = await requestAndParse(route, payload, 'DELETE');

    const success = requestSuccessful(response);
    const message = response.body?.message as string;

    return { success, message };
};

export default deleteStudy;
